import React, { useState } from "react";
import "./Header.css";

const Header = ({ openReportModal }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuLinkClick = () => setMenuOpen(false);

  return (
    <nav className="site-navbar">
      <a href="https://scamcheck.boomlive.in/" className="scamcheck-link">
      <div className="site-logo">
        <i className="fas fa-shield-alt" /> ScamCheck
      </div>
      </a>

      {/* Right side: Menu + Button */}
      <div className="nav-right">
        <button
          className="nav-toggle"
          aria-label="Open menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span className={`bar${menuOpen ? " open" : ""}`}></span>
          <span className={`bar${menuOpen ? " open" : ""}`}></span>
          <span className={`bar${menuOpen ? " open" : ""}`}></span>
        </button>

        <ul className={`site-menu${menuOpen ? " open" : ""}`}>
          <li><a href="#home" className="active" onClick={handleMenuLinkClick}>Home</a></li>
          {/* <li><a href="#analytics" onClick={handleMenuLinkClick}>Analytics</a></li> */}
          <li><a href="#stories" onClick={handleMenuLinkClick}>Stories</a></li>
          <li><a href="#scam-types" onClick={handleMenuLinkClick}>Scam Types</a></li>
        </ul>

        <button className="header-btn" onClick={openReportModal}>
          Report Scam
        </button>
      </div>
    </nav>
  );
};

export default Header;
